<script setup lang="ts">
import { inject, ref, watch, nextTick, computed } from 'vue'

const openValue = inject('openValue')
const value = inject('value') as string

const isOpen = computed(() => openValue?.value === value)
const el = ref<HTMLElement | null>(null)
const height = ref('0px')

watch(isOpen, async (newVal) => {
  await nextTick()
  if (el.value) {
    if (newVal) {
      height.value = el.value.scrollHeight + 'px'
    } else {
      height.value = '0px'
    }
  }
})
</script>

<template>
  <div
    ref="el"
    :style="{ height }"
    class="overflow-hidden transition-[height] duration-300 text-sm"
  >
    <div class="pb-4 pt-4">
      <slot />
    </div>
  </div>
</template>
